import React, { useEffect, useRef, useState } from 'react';

export default function MobileProductMenu({
  label,
  icon = 'three-dots',
  children,
  className = '',
  disabled = false,
  align = 'end',
}) {
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const toggle = useRef(null);
  useEffect(() => {
    if (!open) return;
    const closeOutside = event => {
      if (!root.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', closeOutside);
    document.addEventListener('touchstart', closeOutside);
    return () => {
      document.removeEventListener('mousedown', closeOutside);
      document.removeEventListener('touchstart', closeOutside);
    };
  }, [open]);
  useEffect(() => {
    if (disabled) setOpen(false);
  }, [disabled]);
  const handleKeyDown = event => {
    if (event.key === 'Escape') {
      setOpen(false);
      toggle.current?.focus();
      event.stopPropagation();
    }
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (!open) {
        setOpen(true);
        return;
      }
      const items = Array.from(root.current.querySelectorAll('.dropdown-item:not(:disabled)'));
      const index = items.indexOf(document.activeElement);
      const next = index + (event.key === 'ArrowDown' ? 1 : -1);
      items[(next + items.length) % items.length]?.focus();
    }
  };
  useEffect(() => {
    if (open) root.current?.querySelector('.dropdown-item:not(:disabled)')?.focus();
  }, [open]);
  return (
    <div ref={root} className={`dropdown mp-menu ${className}`} onKeyDown={handleKeyDown}>
      <button
        ref={toggle}
        type='button'
        className='btn btn-light btn-sm dropdown-toggle mp-menu-toggle'
        aria-label={label}
        aria-expanded={open}
        title={label}
        disabled={disabled}
        onClick={() => setOpen(value => !value)}
      >
        <i className={`bi bi-${icon}`} aria-hidden='true' />
      </button>
      {open && (
        <div
          className={`dropdown-menu show mp-menu-${align}`}
          onClick={event => {
            const item = event.target.closest('.dropdown-item');
            if (item && !item.disabled) setOpen(false);
          }}
          onBlur={event => {
            if (!event.currentTarget.parentElement.contains(event.relatedTarget)) setOpen(false);
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
}
